import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const openActivities = (centerId: number) => {
  return restApiClient
    .url(constructApiUrl(API.centers.openActivities.url, { id: centerId }))
    .post()
}
